/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-center text-green-500"
};
const _hoisted_2 = {
  key: 0,
  class: "wrap text-center text-xs text-red-500"
};
const _hoisted_3 = {
  class: "form-control w-full max-w-xs"
};
const _hoisted_4 = {
  class: "input input-bordered flex items-center gap-2"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  class: "h-4 w-4 opacity-70"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z"
})], -1);
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  key: 0,
  class: "label-text-alt text-xs text-red-500"
};
const _hoisted_8 = {
  class: "form-control w-full max-w-xs"
};
const _hoisted_9 = {
  class: "input input-bordered flex items-center gap-2"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  class: "h-4 w-4 opacity-70"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z",
  "clip-rule": "evenodd"
})], -1);
const _hoisted_11 = {
  class: "label"
};
const _hoisted_12 = {
  key: 0,
  class: "label-text-alt text-xs text-red-500"
};
const _hoisted_13 = ["disable"];
import useWPClient from '@/composables/services/useWPClient';
import { useAuthStore } from '@/stores/auth';
export default {
  __name: 'LoginForm',
  emits: ['loggedIn'],
  setup(__props, {
    emit: __emit
  }) {
    const WPClient = useWPClient();
    const authStore = useAuthStore();
    const {
      setToken,
      setUser,
      setTokenToCookie
    } = authStore;
    const emit = __emit;

    // State
    const isSending = ref(false);

    // Fields
    const username = ref('');
    const password = ref('');
    const inputErrors = ref({
      username: false,
      password: false
    });
    const submitError = ref('');
    const submitSuccess = ref('');
    async function handleSubmit() {
      try {
        isSending.value = true;
        if (!username.value || !password.value) {
          inputErrors.value = {
            username: !username.value,
            password: !password.value
          };
          return;
        }
        inputErrors.value = {
          username: false,
          password: false
        };
        const data = await WPClient.login({
          username: username.value,
          password: password.value
        });
        if (data) {
          const {
            token,
            user
          } = data;
          setToken(token);
          setUser(user);
          setTokenToCookie(token);
          submitSuccess.value = 'Login successful';
          setTimeout(() => {
            login_modal.close(); // THIS WORKS

            setTimeout(() => {
              username.value = '';
              password.value = '';
              submitSuccess.value = '';
            }, 500);
          }, 1500);
          emit('loggedIn');
        }
      } catch (error) {
        console.error('LOGIN ERROR', error);
        submitError.value = 'Something went wrong. Please check your credentials and try again.';
      } finally {
        isSending.value = false;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_unref(submitSuccess) ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(submitSuccess)), 1)) : (_openBlock(), _createElementBlock("form", {
        key: 1,
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        class: "flex flex-col items-center gap-4"
      }, [_unref(submitError) ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(submitError)), 1)) : _createCommentVNode("", true), _createElementVNode("label", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "grow text-white",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(username) ? username.value = $event : null)
      }, null, 512), [[_vModelText, _unref(username)]])]), _createElementVNode("div", _hoisted_6, [_unref(inputErrors).username ? (_openBlock(), _createElementBlock("span", _hoisted_7, " * Username is required ")) : _createCommentVNode("", true)])]), _createElementVNode("label", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "grow text-white",
        placeholder: "********",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(password) ? password.value = $event : null)
      }, null, 512), [[_vModelText, _unref(password)]])]), _createElementVNode("div", _hoisted_11, [_unref(inputErrors).password ? (_openBlock(), _createElementBlock("span", _hoisted_12, " * Password is required ")) : _createCommentVNode("", true)])]), _createElementVNode("button", {
        class: "btn btn-primary !text-white",
        disable: _unref(isSending)
      }, "Login", 8, _hoisted_13)], 32))]);
    };
  }
};